var SidepanelModule = /** @class */ (function () {
    function SidepanelModule() {
    }
    return SidepanelModule;
}());
export { SidepanelModule };
